import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ContentEnum, GridCell, RowCell } from '../../models/sections-model';

@Component({
  selector: 'kw-edit-placeholder-renderer',
  templateUrl: './edit-placeholder-renderer.component.html',
  styleUrls: ['./edit-placeholder-renderer.component.scss']
})
/**
 * Temporary placeholder for grid/row cells whic is used during the creation stage
 * Shows an SVG in place of the cell content
 * The click event is handled by the hosting rendererComponent
 * 
 */
export class EditPlaceholderRendererComponent implements OnChanges, AfterViewInit{
  @Input() gridCell:GridCell|RowCell;
  cntEnum:ContentEnum;
  textColor:string = '#777777';
  fillColor:string ="#cccccc"
  svgText:string;
  maxWidth:number;

  @ViewChild('mySvg', { static: true }) mySvg!: ElementRef;
  /**
   * Emits the selected cell that will be populated using the dialog
   * 
   */
  @Output() createGridCellContent = new EventEmitter<GridCell|RowCell>

  constructor(private renderer: Renderer2){
    console.log(this.gridCell)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["gridCell"]){
      console.log(this.gridCell);
      this.cntEnum = this.gridCell.contentEnum;
      if(this.cntEnum){
        this.resolveSvgText(this.cntEnum);
        console.log(this.cntEnum);
      }
    }
  }

  ngAfterViewInit(): void {
    //Get the svg width;
    let mySvgEl = <HTMLElement>this.mySvg.nativeElement;
    let maxWidth = mySvgEl.offsetWidth - 12;
    this.addTextToSvg(this.svgText, "50%","50%");
    this.renderer.listen(this.mySvg.nativeElement, 'click', () => {
      console.log("SVG element clicked!");
      this.createGridCellContent.emit(this.gridCell);
    });
  }

  resolveSvgText(cntEnum){
    let enumValue;
    if((cntEnum).includes(".")){
      let enumKey = cntEnum.split('.')[1] as keyof typeof ContentEnum;
      enumValue = ContentEnum[enumKey];
    }else{
      enumValue = ContentEnum[cntEnum];
    }
    if(enumValue == undefined){
      console.log(cntEnum)
      enumValue = cntEnum;
    }
    /**
     * PRODUCT = "Product Content",
    CATEGORY = "Category Content",
    PROMO_TEXT = "Promotional Text",
    CALL_TO_ACTION = "Call To Action",
    BLOG_ARTICLE_LINK = "Blog Article Link",
    CATEGORY_LINK = "Category Link",
    PRODUCT_LINK = "Product Link",
    BANNER = "Banner",
    HEADLINE = "Headline",
    SUB_HEADLINE = "Sub Headline",
    GALLERY = "Gallery",
    PRODUCT_CLASSIFICATION = "Product Classification",
    PRODUCT_ID = "Product Identification",
    PRODUCT_STD_FEATS = "Product Standard Features",
    PRODUCT_SELC_FEATS = "Product Selectable Features",
    PRODUCT_PRICING = "Product Price",
    PRODUCT_RATING = "Product Rating",
    PRODUCT_DIMENSIONS = "Product Rating",
    PRODUCT_PACKAGING = "Product Packaging",
    PRODUCT_SHORT_DESC = "Product Short Description",
    PRODUCT_LONG_DESC = "Product Long Description",
    PRODUCT_REVIEWS = "Product Reviews",
    PRODUCT_ADD_TO_CART = "Add To Cart",
    PRODUCT_SHARE = "Product Share",
    PRODUCT_DELIVERY = "Delivery",
    PRODUCT_INVENTORY = "Inventory",
    PRODUCT_VARIANT = "Product Variant",
    GENERAL_TEXT = "General Text",
    SHOPPINGCART = "Shopping Cart",
    BLOG_HEADER = "Blog Header",
    BLOG_SUMMARY = "Blog Summary",
    BLOG_MAIN = "Blog Main",
    BLOG_SHARE = "Blog Share",
    BLOG_COMMENTS = "Blog Comments",
    BLOG_IMAGE = "Blog Image",
    NAV_LIST = "Navigation List",
    PRODUCT_CELL = "Product Cell",
    HERO_IMAGE = "Hero Image
     */
    console.log(enumValue);
    switch (enumValue) {
      case "Product Link":
        this.svgText = "Create Product Link Content"
        break;
      case "Banner":
        this.svgText = "Create Banner Content"
        break;
      case "Blog Article Link":
        this.svgText = "Create Blog Link Content"
        break;
      case "Call To Action":
        this.svgText = "Create News Letter Sign Up"        
        break;
      case "Product Cell":
        this.svgText = "Load Product Summary"        
        break;
      case "Feature":
        this.svgText = "Create Store Feature"        
        break;
      case "Testimonial":
        this.svgText = "Create Testimonial"        
        break;
      case "Hero Image":
        this.svgText = "Create Hero Image"        
        break;
      default:
        break;
    }
  }

  addTextToSvg(text: string, x: string, y: string): void {
    // Create the <text> element
    //const textElement = this.renderer.createElement('text', 'svg');

    // Set text content
    //this.renderer.setProperty(textElement, 'textContent', text);

    // Set attributes for positioning and styling
    /* this.renderer.setAttribute(textElement, 'x', x.toString());
    this.renderer.setAttribute(textElement, 'y', y.toString());
    this.renderer.setAttribute(textElement, 'font-size', '20');
    this.renderer.setAttribute(textElement, 'text-anchor', 'middle');
    this.renderer.setAttribute(textElement, 'fill', this.textColor);
    this.renderer.setAttribute(textElement, 'dy', '.3em'); */


    // Append the <text> element to the <svg>
    //this.renderer.appendChild(this.mySvg.nativeElement, textElement);

    /* const words = text.split(' ');

    let line = '';
    const lines = []; */

    /* words.forEach((word) => {
      const testLine = line + word + ' ';
      textElement.textContent = testLine;
      const textWidth = textElement.getBBox().width;

      if (textWidth > this.maxWidth) {
        lines.push(line);
        line = word + ' ';
      } else {
        line = testLine;
      }
    }); */
    //lines.push(line);  // add the last line
    //console.log(lines)
    //textElement.remove();  // cleanup temporary text element

    // Clear any existing content
    //this.mySvg.nativeElement.innerHTML = '';
    // Add wrapped lines as <tspan> elements
    /* lines.forEach((lineText, index) => {
      const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
      tspan.setAttribute('x', '10');  // Horizontal position
      tspan.setAttribute('dy', index === 0 ? '0' : '1.2em');  // Vertical spacing
      tspan.textContent = lineText;
      this.mySvg.nativeElement.appendChild(tspan);
    }); */
  }

  changeFillColor(color: string) {
    this.fillColor = color;
  }
  

}
